// Basic
import { useState } from 'react';
import PropTypes from 'prop-types';
// Store & actions
import useSessionStore from '@/app/store/session';
import useCustomPayStore from '@/app/store/customPay';
// Components
import ModalBlacklistPosTerminal from '@/app/modules/terminals/components/modals/status/ModalBlacklistPosTerminal';
import ModalUnblacklistPosTerminal from '@/app/modules/terminals/components/modals/status/ModalUnblacklistPosTerminal';
import ModalRewarehousePosTerminal from '@/app/modules/terminals/components/modals/rewarehouse/ModalRewarehousePosTerminal';
import ModalScheduledTerminateSubscription from '../modals/ModalScheduledTerminateSubscription';
import ModalScheduledBlacklistPosTerminal from '@/app/modules/terminals/components/modals/status/ModalScheduledBlacklistPosTerminal';
import ModalTerminateSubscription from '../modals/ModalTerminateSubscription';
import ModalActivateSubscription from '../modals/ModalActivateSubscription';
import ModalMigrateSubscription from '../modals/ModalMigrateSubscription';
import ModalShowPosTerminalInfo from '@/app/modules/terminals/components/modals/status/ModalShowPosTerminalInfo';
import ModalAllowTemporarily from '@/app/modules/terminals/components/modals/status/ModalAllowTemporarily';
import ModalUpdateSubscriptionWithOrWithoutPlan from '../modals/ModalUpdateSubscriptionWithOrWithoutPlan';
import ModalUpdateLabels from '@/app/modules/terminals/components/modals/updateLabels/ModalUpdateLabels';
import ModalAddEnvelope from '../modals/ModalAddEnvelope';
import Dropdown from '@/common-utils/components/renders/dropdown/Dropdown';
// Common
import GenerateActionsSubscriptionLifecycle from './actions/generateActionsSubscriptionLifecycle';
import ICONS from '@/common-utils/enums/icons';
import GenerateActionsPosTerminalLifecycle from '../../../terminals/components/dropdown/actions/generateActionsPosTerminalLifecycle';
import CustomPayGenerateActionsSubscriptionLifecycle from './actions/CustomPayGenerateActionsSubscriptionLifecycle';
import subscriptionFields from '../../fields/subscriptionFields';
import Permissions from '@/app/permissions/Permissions';
// Lang
import { nsSubscription, nsTerminal } from '@/app/i18n/namespaces';
import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import hasRequiredPermissions from '@/common-utils/functions/hasRequiredPermissions';
import TAB_KEYS_HISTORICS from '@/app/root/enums/tabs/HistoricsTabs';
import { buildUrl } from '@/common-utils/functions/restUtils';
import RouteUrls from '@/app/root/enums/RouteUrls';
import historicsFields from '@/app/modules/historics/fields/historicsFields';
import { useNavigate } from 'react-router-dom';



/**
 * @param root0
 * @param root0.subscription
 * @param root0.setLaunchRefetch
 * @returns {JSX}
 */
function DropdownSubscriptionsActionsRow({ subscription, setLaunchRefetch }) {

    // Router
    const navigate = useNavigate();

    // Store
    const permissions = useSessionStore(s => s.session.permissions);
    const isCustomPay = useCustomPayStore(s => s.isCustomPay);

    // State
    // Modals functions for subscriptions
    const [showModalActivateSubscription, setShowModalActivateSubscription] = useState(false);
    const handleShowModalActivateSubscription = () => {
        setShowModalActivateSubscription(true);
    };
    const [showModalTerminateSubscription, setShowModalTerminateSubscription] = useState(false);
    const handleShowModalTerminateSubscription = () => {
        setShowModalTerminateSubscription(true);
    };
    const [showModalScheduledTerminateSubscription, setShowModalScheduledTerminateSubscription] = useState(false);
    const handleShowModalScheduledTerminateSubscription = () => {
        setShowModalScheduledTerminateSubscription(true);
    };
    const [showModalMigrateSubscription, setShowModalMigrateSubscription] = useState(false);
    const handleShowModalMigrateSubscription = () => {
        setShowModalMigrateSubscription(true);
    };
    const [showModalUpdateSubscriptionWithOrWithoutPlan, setShowModalUpdateSubscriptionWithOrWithoutPlan] = useState(false);
    const handleShowModalUpdateSubscriptionWithOrWithoutPlan = () => {
        setShowModalUpdateSubscriptionWithOrWithoutPlan(true);
    };
    const [showModalAddEnvelope, setShowModalAddEnvelope] = useState(false);

    // Modals functions for POS terminals
    const [showModalTemporarilyAllow, setShowModalTemporarilyAllow] = useState(false);
    const handleShowModalTemporarilyAllow = () => {
        setShowModalTemporarilyAllow(true);
    };
    const [showModalBlacklistPosTerminal, setShowModalBlacklistPosTerminal] = useState(false);
    const handleShowModalBlacklistPosTerminal = () => {
        setShowModalBlacklistPosTerminal(true);
    };
    const [showModalUnblacklistPosTerminal, setShowModalUnblacklistPosTerminal] = useState(false);
    const handleShowModalUnblacklistPosTerminal = () => {
        setShowModalUnblacklistPosTerminal(true);
    };
    const [showModalRewarehousePosTerminal, setShowModalRewarehousePosTerminal] = useState(false);
    const handleShowModalRewarehousePosTerminal = () => {
        setShowModalRewarehousePosTerminal(true);
    };
    const [showModalScheduledBlacklistPosTerminal, setShowModalScheduledBlacklistPosTerminal] = useState(false);
    const handleShowModalScheduledBlacklistPosTerminal = () => {
        setShowModalScheduledBlacklistPosTerminal(true);
    };
    const [showModalUpdatePosTerminal, setShowModalUpdatePosTerminal] = useState(false);
    const [showModalPosTerminalInfo, setShowModalPosTerminalInfo] = useState(false);

    return (
        <>
            <Dropdown
                dataCy='subscription-actions-dropdown-row'
                triggerValues={{ variant: 'ghostNoBorder', icon: ICONS.MORE }}
                actions={[
                    {
                        icon: ICONS.SUBSCRIPTION,
                        trigger: 'actions.row.subscription',
                        namespace: nsSubscription,
                        visible: true,
                        subActions: isCustomPay ?
                            [
                                ...CustomPayGenerateActionsSubscriptionLifecycle(
                                    subscription,
                                    permissions,
                                    {
                                        handleShowModalActivateSubscription,
                                        handleShowModalTerminateSubscription,
                                        handleShowModalScheduledTerminateSubscription,
                                        handleShowModalUpdateSubscriptionWithOrWithoutPlan
                                    }
                                )
                            ]
                            : [
                                ...GenerateActionsSubscriptionLifecycle(
                                    subscription,
                                    permissions,
                                    {
                                        handleShowModalActivateSubscription,
                                        handleShowModalTerminateSubscription,
                                        handleShowModalScheduledTerminateSubscription,
                                        handleShowModalMigrateSubscription,
                                        handleShowModalUpdateSubscriptionWithOrWithoutPlan
                                    }
                                )
                            ]
                    },
                    {
                        icon: ICONS.SMARTPHONE,
                        trigger: 'actions.row.terminal',
                        namespace: nsSubscription,
                        visible: true,
                        subActions: [
                            ...GenerateActionsPosTerminalLifecycle(
                                subscription,
                                permissions,
                                {
                                    handleShowModalTemporarilyAllow,
                                    handleShowModalBlacklistPosTerminal,
                                    handleShowModalUnblacklistPosTerminal,
                                    handleShowModalRewarehousePosTerminal,
                                    handleShowModalScheduledBlacklistPosTerminal
                                }
                            ),
                            {
                                icon: ICONS.EDIT,
                                entity: 'actions.row.update_labels',
                                namespace: nsTerminal,
                                onClick: () => setShowModalUpdatePosTerminal(true),
                                visible: true,
                                disabled: !hasRequiredPermissions({
                                    permissions: permissions,
                                    requiredPermissions: [Permissions.POS_TERMINAL_UPDATE.name]
                                }),
                                tooltipForbidden: 'title.permissions.access_denied'
                            },
                            {
                                icon: ICONS.ADD_ENVELOPES,
                                entity: 'actions.row.add_envelope',
                                namespace: nsSubscription,
                                onClick: () => setShowModalAddEnvelope(true),
                                visible: true,
                                disabled: !hasRequiredPermissions({
                                    permissions: permissions,
                                    requiredPermissions: [Permissions.CSV_INSERT_POS_REMOTE_DOWNLOAD.name]
                                }),
                                tooltipForbidden: 'title.permissions.access_denied'
                            },
                            {
                                icon: ICONS.INFO,
                                entity: 'actions.row.posTerminal_info_pos_status',
                                namespace: nsTerminal,
                                onClick: () => setShowModalPosTerminalInfo(true),
                                visible: true,
                                disabled: !hasRequiredPermissions({
                                    permissions: permissions,
                                    requiredPermissions: [Permissions.VISUALISE_POS_TERMINAL_STATUS_ON_GATEWAY.name]
                                }),
                                tooltipForbidden: 'title.permissions.access_denied'
                            }
                        ]
                    },
                    {
                        icon: ICONS.HISTORY,
                        entity: 'actions.row.historics_access',
                        namespace: nsSubscription,
                        onClick: () => {
                            const serialNumber = subscription ? getObjectAttributeFromStringKey(
                                subscription,
                                generateNestedFieldAccessor(subscriptionFields.POS_TERMINAL.SERIAL_NUMBER)
                            ) : null;
                            const posTerminalHistorics = buildUrl(RouteUrls.HISTORICS.url,
                                {
                                    view: TAB_KEYS_HISTORICS.POS_TERMINALS.name,
                                    filters: serialNumber ? [
                                        {
                                            key: historicsFields.POS_TERMINALS_HISTORICS.SERIAL_NUMBER.key,
                                            value: serialNumber
                                        }
                                    ] : []
                                }
                            );
                            navigate(posTerminalHistorics);
                        },
                        visible: true,
                        disabled: !hasRequiredPermissions({
                            permissions: permissions,
                            requiredPermissions: [Permissions.LIST_HISTORY.name]
                        }),
                        tooltipForbidden: 'title.permissions.access_denied'
                    }
                ]} />

            {
                // Subscription action
                showModalActivateSubscription &&
                <ModalActivateSubscription
                    isOpen={showModalActivateSubscription}
                    setIsOpen={setShowModalActivateSubscription}
                    subscriptionId={subscription.uuid}
                    clientId={subscription.client.uuid}
                    directProviderId={getObjectAttributeFromStringKey(
                        subscription,
                        generateNestedFieldAccessor(subscriptionFields.POS_TERMINAL.DIRECT_PROVIDER.PROVIDER_UUID)
                    )}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                // Subscription action
                showModalTerminateSubscription &&
                <ModalTerminateSubscription
                    isOpen={showModalTerminateSubscription}
                    setIsOpen={setShowModalTerminateSubscription}
                    subscriptionId={subscription.uuid}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                // Subscription action
                showModalScheduledTerminateSubscription &&
                <ModalScheduledTerminateSubscription
                    isOpen={showModalScheduledTerminateSubscription}
                    setIsOpen={setShowModalScheduledTerminateSubscription}
                    subscriptionId={subscription.uuid}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                // Subscription action
                showModalMigrateSubscription &&
                <ModalMigrateSubscription
                    isOpen={showModalMigrateSubscription}
                    setIsOpen={setShowModalMigrateSubscription}
                    subscriptionId={subscription.uuid}
                    subcriptionStartBillingDate={subscription[subscriptionFields.START_BILLING_DATE.key]}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                // Subscription action
                showModalUpdateSubscriptionWithOrWithoutPlan &&
                <ModalUpdateSubscriptionWithOrWithoutPlan
                    isOpen={showModalUpdateSubscriptionWithOrWithoutPlan}
                    setIsOpen={setShowModalUpdateSubscriptionWithOrWithoutPlan}
                    subscriptionId={subscription.uuid}
                    allowedClientId={subscription[subscriptionFields.MERCHANT_ORGANIZATION.key]}
                    organizationId={
                        getObjectAttributeFromStringKey(subscription,
                            generateNestedFieldAccessor(subscriptionFields.POS_TERMINAL.DIRECT_PROVIDER.PROVIDER_UUID))
                    }
                />
            }
            {
                // Subscription action
                showModalAddEnvelope &&
                <ModalAddEnvelope
                    isOpen={showModalAddEnvelope}
                    setIsOpen={setShowModalAddEnvelope}
                    subscriptionId={subscription.uuid}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }

            {
                // POS terminal action
                showModalTemporarilyAllow &&
                <ModalAllowTemporarily
                    isOpen={showModalTemporarilyAllow}
                    setIsOpen={setShowModalTemporarilyAllow}
                    subscriptionId={subscription.uuid}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                // POS terminal action
                showModalBlacklistPosTerminal &&
                <ModalBlacklistPosTerminal
                    isOpen={showModalBlacklistPosTerminal}
                    setIsOpen={setShowModalBlacklistPosTerminal}
                    subscriptionId={subscription.uuid}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                // POS terminal action
                showModalUnblacklistPosTerminal &&
                <ModalUnblacklistPosTerminal
                    isOpen={showModalUnblacklistPosTerminal}
                    setIsOpen={setShowModalUnblacklistPosTerminal}
                    subscriptionId={subscription.uuid}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                // POS terminal action
                showModalRewarehousePosTerminal &&
                <ModalRewarehousePosTerminal
                    isOpen={showModalRewarehousePosTerminal}
                    setIsOpen={setShowModalRewarehousePosTerminal}
                    subscriptionId={subscription.uuid}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                // POS terminal action
                showModalScheduledBlacklistPosTerminal &&
                <ModalScheduledBlacklistPosTerminal
                    isOpen={showModalScheduledBlacklistPosTerminal}
                    setIsOpen={setShowModalScheduledBlacklistPosTerminal}
                    subscriptionId={subscription.uuid}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                // POS terminal action
                showModalUpdatePosTerminal &&
                <ModalUpdateLabels
                    isOpen={showModalUpdatePosTerminal}
                    setIsOpen={setShowModalUpdatePosTerminal}
                    posTerminal={subscription[subscriptionFields.POS_TERMINAL.key]}
                    setLaunchRefetch={setLaunchRefetch}
                />
            }
            {
                // POS terminal action
                showModalPosTerminalInfo &&
                <ModalShowPosTerminalInfo
                    isOpen={showModalPosTerminalInfo}
                    setIsOpen={setShowModalPosTerminalInfo}
                    subscriptionId={subscription.uuid}
                />
            }
        </>
    );
}
DropdownSubscriptionsActionsRow.propTypes = {
    subscription: PropTypes.object.isRequired,
    setLaunchRefetch: PropTypes.func.isRequired
};
export default DropdownSubscriptionsActionsRow;